import { render, staticRenderFns } from "./ShopsHead.vue?vue&type=template&id=1ffd6c46&scoped=true"
import script from "./ShopsHead.vue?vue&type=script&lang=js"
export * from "./ShopsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd6c46",
  null
  
)

export default component.exports